module.exports = __webpack_public_path__ + "img/3-4.6fa4ca94.svg";